import {gsap, Power3} from 'gsap';

export class ScrollTo {
    constructor() {
        this.obj = document.querySelectorAll(".js-scroll-to");
        this.current = null;

        if (this.obj.length > 0) {
            this.init();
        }
    }

    init() {
        const defaultOffset = 0;

        for (let item of this.obj) {
            const target = document.querySelector(`${item.dataset.target}`);
            let offset = -parseInt(item.dataset.offset);
            if (!target) {
                return;
            }
            if (!offset) {
                offset = defaultOffset;
            }

            item.addEventListener('click', () => {
                gsap.to([document.documentElement, document.body], 1, {
                    scrollTop: -document.body.getBoundingClientRect().y + target.getBoundingClientRect().y + offset,
                    ease: Power3.easeOut
                });
            });
        }
    }
}
